import React, { useState } from 'react';
import { KeenIcon } from '@/components';

// Component Header cho modal (tương tự như ManageModal)
const ModalHeader = ({
  title,
  onClose
}) => {
  return (
    <div className="flex items-center justify-between p-6 border-b border-gray-200">
      <h3 className="text-xl font-semibold text-gray-900">{title}</h3>
      <button onClick={onClose} className="text-gray-400 hover:text-gray-600">
        <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
        </svg>
      </button>
    </div>
  );
};

// Component Footer cho modal
const ModalFooter = ({
  onSave
}) => {
  return (
    <div className="flex items-center p-6 space-x-2 border-t border-gray-200 rounded-b justify-end w-full">
      <button
        className='bg-green-500 px-3 py-2 rounded-md text-white'
        onClick={onSave}
      >
        Save
      </button>
    </div>
  );
};

const AttachFileManagerModal = ({
  isOpen,
  onClose,
  onSave
}) => {
  const [name, setName] = useState('');
  const [file, setFile] = useState(null);
  const [detail, setDetail] = useState('');

  const handleSave = () => {
    // TODO: Implement save logic
    console.log('Saving:', { name, file, detail });
    onSave({ name, file, detail });
    // Reset form
    setName('');
    setFile(null);
    setDetail('');
    // Việc đóng modal sẽ được gọi từ component cha sau khi xử lý onSave
  };

  const handleFileChange = (event) => {
    const selectedFile = event.target.files ? event.target.files[0] : null;
    setFile(selectedFile);
  };

  if (!isOpen) return null; // Chỉ render khi isOpen là true

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/30"> {/* Backdrop */}
      <div className="bg-white rounded-lg shadow-lg w-[90vw] max-w-2xl min-h-[60%] relative flex flex-col pb-12"> {/* Modal Content */}
        <ModalHeader title="Attach Files" onClose={onClose} />
        <div className="p-6 flex flex-col gap-4 flex-grow"> {/* Modal Body */}
          <div>
            <label htmlFor="name" className="block text-sm font-medium text-gray-700">Name</label>
            <input
              type="text"
              id="name"
              className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm p-2"
              value={name}
              onChange={(e) => setName(e.target.value)}
            />
          </div>
          <div>
            <label htmlFor="attach-file" className="block text-sm font-medium text-gray-700">Attach File (File pdf; word; txt Max 20 MB)</label>
            <input
              type="file"
              id="attach-file"
              className="mt-1 block w-full text-sm text-gray-500
                file:mr-4 file:py-2 file:px-4
                file:rounded-md file:border-0
                file:text-sm file:font-semibold
                file:bg-green-50 file:text-green-700
                hover:file:bg-green-100"
              onChange={handleFileChange}
            />
          </div>
          <div>
            <label htmlFor="detail" className="block text-sm font-medium text-gray-700">Detail</label>
            <textarea
              id="detail"
              rows="4"
              className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm p-2"
              value={detail}
              onChange={(e) => setDetail(e.target.value)}
            ></textarea>
          </div>
        </div>
        <ModalFooter onSave={handleSave} />
      </div>
    </div>
  );
};

export { AttachFileManagerModal }; 